import { useQueryParams, ArrayParam, StringParam } from "routing/QueryParams";
import useQuery from "routing/useQuery";
import { timeRangeFromQueryParameter, timeRangeToQueryParameter } from "views/logic/TimeRange";
const SEVEN_DAYS_IN_SECONDS = 7 * 24 * 60 * 60;
const DEFAULT_TIME_RANGE = { type: "relative", range: SEVEN_DAYS_IN_SECONDS };
const QUERY_PARAMS = {
  rangetype: StringParam,
  relative: StringParam,
  from: StringParam,
  to: StringParam,
  keyword: StringParam,
  feature_id: ArrayParam,
  provider: ArrayParam,
  model: ArrayParam
};
const NO_TIME_RANGE = { rangetype: void 0, relative: void 0, from: void 0, to: void 0, keyword: void 0 };
const useTokenUsageSearch = () => {
  const query = useQuery();
  const [{ feature_id: featureIds, provider, model }, setQuery] = useQueryParams(QUERY_PARAMS);
  const search = {
    timerange: "rangetype" in query ? timeRangeFromQueryParameter(query) : DEFAULT_TIME_RANGE,
    feature_id: featureIds != null ? featureIds : [],
    provider: provider != null ? provider : [],
    model: model != null ? model : []
  };
  const setSearch = ({ timerange, ...filters }) => setQuery({ ...NO_TIME_RANGE, ...timeRangeToQueryParameter(timerange), ...filters });
  return [search, setSearch];
};
export default useTokenUsageSearch;
